export default __webpack_public_path__ + "static/media/ComunicadoMarcacionTH.e0e43b59.jpg";